var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticStyle:{"width":"100%"},attrs:{"gutter":20}},[_c('el-col',{attrs:{"span":12,"offset":3}},[(_vm.$route.path!='/')?_c('myMenu'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }